import React from 'react';
import ProspectiveLossComponent from "./ProspectiveLossComponent";

const ProspectiveLossContainer = (props) => {

	if (!props.prospectiveLosses) {
		return <div>Loading</div>
	}

	return (
		<React.Fragment>
			<ProspectiveLossComponent prospectiveLosses={props.prospectiveLosses}  lossType={props.lossType}/>
		</React.Fragment>
	);

};


export default ProspectiveLossContainer;


// WEBPACK FOOTER //
// ./src/common/components/ProspectiveLoss/ProspectiveLossContainer.js